import { BaseControl, BaseControlProps, IconButton, useTranslations } from "@bsm/component";
import { useMemo, useCallback } from "react";
import moment from "moment";

export const WorkingDayCheckControl = (props: Props) => {

    const [WORKING_DAYS_DIALOG_MESSAGE] = useTranslations(i18n);

    const workingDaysOptions = useMemo(() => {
        return props?.workingDays?.map((wd: any) => ({
            id: wd.id,
            label: `${moment(wd.startDate).format('DD/MM/YYYY')}`,
            date: wd.startDate,
            isWeeklyRepetitive: wd.isWeeklyRepetitive,
        })) || [];
    }, [props.workingDays]);

    const checkboxValue = useMemo(() => {
        return props.value || [];
    }, [props.value]);

    const handleToggle = useCallback((date: string) => {
        const isSelected = checkboxValue.includes(date);
        const newValue = isSelected
            ? checkboxValue.filter((d) => d !== date)
            : [...checkboxValue, date];
        props.onChange?.(newValue);
    }, [checkboxValue, props.onChange]);

    return (
        <BaseControl {...props}>
            <div className="w-full bg-[#00000008] rounded-md px-2 py-4">
                <div className="max-h-[300px] overflow-y-auto space-y-3">
                    {workingDaysOptions.map((workingDay) => {
                        const isSelected = checkboxValue.includes(workingDay.date);
                        return (
                            <div key={workingDay.id} className="p-2">
                                <div className="text-xs text-gray-600">
                                    {WORKING_DAYS_DIALOG_MESSAGE}
                                </div>
                                <div
                                    className="flex items-center gap-2 cursor-pointer mb-2"
                                    onClick={() => handleToggle(workingDay.date)}
                                >
                                    <IconButton
                                        icon={isSelected ? 'fa-check-square' : 'fa-square'}
                                        onClick={() => handleToggle(workingDay.date)}
                                    />
                                    <span>{workingDay.label}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </BaseControl>
    );
}

const i18n = [
    'BSMRH.Calendar.TimeOff.Create.WorkingDays.Dialog.Message'
]

type Props = BaseControlProps & {
    value?: Array<string>;
    onChange: (value: Props["value"]) => void;
    workingDays?: Array<any>;
};